import React from 'react';
import { GoalEmployee, GoalTeam, GoalType } from '../../types';
import { getGoalTypeStr } from '../../translations';

type Props = {
  goalType: GoalType;
  goalEmployee?: GoalEmployee; // undefined if type team or company
  goalTeam?: GoalTeam;
};

export const GoalHierarchyItemLabels: React.FC<Props> = ({
  goalType,
  goalEmployee,
  goalTeam,
}) => {
  return (
    <>
      <span className="text-muted small">({getGoalTypeStr(goalType)})</span>
      {goalTeam && <i>{goalTeam.name}</i>}
      {goalEmployee && <i>{goalEmployee.name}</i>}
    </>
  );
};
